'use client';

import React, { useEffect, useState } from 'react';
import { LoadingButton } from '../ui/loading-button';

const LoadingLink = ({
    variant,
    children,
    className,
    loading,
}: {
    className?: string;
    children?: React.ReactNode;
    loading?: boolean;
    variant?:
        | 'default'
        | 'destructive'
        | 'outline'
        | 'secondary'
        | 'ghost'
        | 'link'
        | 'btnMain'
        | 'blue'
        | null
        | undefined;
}) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(Boolean(loading));
    }, [loading]);

    return (
        <LoadingButton
            variant={variant}
            disabled={isLoading}
            loading={isLoading}
            size={variant ? undefined : 'sm'}
            asChild
            className={
                variant
                    ? className
                    : `${className} bg-primary hover:bg-lime-500 h-7 lg:font-bold text-[12px]`
            }
        >
            <span
                aria-disabled={isLoading}
                onClick={isLoading ? undefined : () => setIsLoading(true)}
            >
                {children ?? 'دریافت نوبت'}
            </span>
        </LoadingButton>
    );
};

export default LoadingLink;
